var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t('dictionary.elasticcache')}}),_c('page-body',[_c('redis-list',{attrs:{"id":_vm.listId,"cloud-env":_vm.cloudEnv,"cloudEnvOptions":_vm.cloudEnvOptions}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }